export const toCamel = (str: string) => str.replace(/_([a-z])/g, (_, c) => c.toUpperCase());

export const toSnake = (str: string) => str.replace(/[A-Z]/g, (c) => `_${c.toLowerCase()}`);

export function keysToCamel(obj: any): any {
  if (Array.isArray(obj)) return obj.map(keysToCamel);
  if (obj !== null && typeof obj === 'object') {
    return Object.fromEntries(Object.entries(obj).map(([key, value]) => [toCamel(key), keysToCamel(value)]));
  }
  return obj;
}

export function keysToSnake(obj: any): any {
  if (Array.isArray(obj)) return obj.map(keysToSnake);
  if (obj !== null && typeof obj === 'object') {
    return Object.fromEntries(Object.entries(obj).map(([key, value]) => [toSnake(key), keysToSnake(value)]));
  }
  return obj;
}
